import { render } from "./TestReadingNormal.vue?vue&type=template&id=6f488d92&scoped=true"
import script from "./TestReadingNormal.vue?vue&type=script&lang=js"
export * from "./TestReadingNormal.vue?vue&type=script&lang=js"

import "./TestReadingNormal.vue?vue&type=style&index=0&id=6f488d92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f488d92"]])

export default __exports__